import { map } from 'lodash'
import moment from 'moment'
import { success } from '@/utils/alert'

export default {
  formatDate (date) {
    return moment(date).format('DD/MM')
  },
  doConfirmedAll () {
    const ids = map(this.schedules, schedule => {
      return schedule.id
    })

    this.$resource.put(ids.toString() + '/rollback')
      .then(({data}) => {
        success('Horário(s) foram revertido(s) com sucesso.')
        this.$emit('close', data)
      })
      .catch(() => {
        this.$toast.error('Ocorreu um erro ao definido como agendado.')
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/company/gadget/components/active-agenda/components/rollback/resources/methods.js